import React from 'react';
import { ChartBarIcon, LockClosedIcon } from '@heroicons/react/24/outline';

export default function UpgradePrompt({ reason }) {
  return (
    <div className="bg-white rounded-lg shadow p-8 text-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <LockClosedIcon className="w-6 h-6 text-gray-400" />
      </div>

      <h3 className="text-lg font-medium text-gray-900 mb-2">Enhanced Analytics</h3>

      <p className="text-gray-500 mb-6 max-w-md mx-auto">
        Get deeper insights into your passport performance with enhanced analytics.
        See visitor patterns, benchmarking data, and behavioral insights.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="p-4 bg-gray-50 rounded-lg">
          <ChartBarIcon className="w-6 h-6 text-gray-400 mx-auto mb-2" />
          <p className="text-xs text-gray-600">Visitor Conversion</p>
        </div>
        <div className="p-4 bg-gray-50 rounded-lg">
          <ChartBarIcon className="w-6 h-6 text-gray-400 mx-auto mb-2" />
          <p className="text-xs text-gray-600">Benchmarking</p>
        </div>
        <div className="p-4 bg-gray-50 rounded-lg">
          <ChartBarIcon className="w-6 h-6 text-gray-400 mx-auto mb-2" />
          <p className="text-xs text-gray-600">Timing Patterns</p>
        </div>
        <div className="p-4 bg-gray-50 rounded-lg">
          <ChartBarIcon className="w-6 h-6 text-gray-400 mx-auto mb-2" />
          <p className="text-xs text-gray-600">Visitor Behavior</p>
        </div>
      </div>

      <div className="space-y-3">
        <p className="text-sm text-gray-500">
          Enhanced analytics is available for Premium and Reserve tier listings,
          or contact your passport organizer to enable it for your listing.
        </p>
        <a
          href="mailto:support@vinoseeker.com?subject=Enhanced%20Analytics%20Inquiry"
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Contact Support
        </a>
      </div>
    </div>
  );
}
